import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext({
  open: false,
  openModal: () => {},
  closeModal: () => {},
});

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <BookingContext.Provider
      value={{ open, openModal: () => setOpen(true), closeModal: () => setOpen(false) }}
    >
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
